import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const Nav = (props) => {
    const { width } = props;

    return (
        <div className={styles.navWp}>
            <div className={styles.nav} style={{ width: `${width}px` }}>
                <div>
                    <span className={styles.main}>
                        <a href="https://sports.ifeng.com/loc/special/beijing2022" target="_blank" rel="noreferrer">冬奥首页</a>
                    </span>
                    <span className={styles.sub}>
                        <a href="https://sports.ifeng.com/zhty" target="_blank" rel="noreferrer">滚动新闻</a>
                    </span>
                    <span className={styles.sub}>
                        <a href="https://sports.ifeng.com/loc/special/beijing2022/honor" target="_blank" rel="noreferrer">中国骄傲</a>
                    </span>
                    <span className={styles.sub}>
                        <a href="https://sports.ifeng.com/djpl" target="_blank" rel="noreferrer">原创策划</a>
                    </span>
                    <span className={styles.sub}>
                        <a href="https://sports.ifeng.com/photo" target="_blank" rel="noreferrer">精彩图集</a>
                    </span>
                    <span className={styles.sub}>
                        <a href="https://flive.ifeng.com/live/1005717.html" target="_blank" rel="noreferrer">图文直播</a>
                    </span>
                    <span className={styles.sub}>
                        <a href="https://sports.ifeng.com/loc/special/beijing2022/schedule" target="_blank" rel="noreferrer">完整赛程</a>
                    </span>
                    <span className={styles.sub}>
                        <a href="https://sports.ifeng.com/loc/special/beijing2022/awards" target="_blank" rel="noreferrer">奖牌榜</a>
                    </span>
                </div>
                <div>
                    <a href="https://sports.ifeng.com/" target="_blank" rel="noreferrer">体育首页</a>
                </div>
            </div>
        </div>
    );
};

Nav.propTypes = {
    width: PropTypes.number
};

export default errorBoundary(Nav);
